import './animate.css';
import './app.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './responsive.css';
import './style.css';
import 'font-awesome/css/font-awesome.css';


// WEBPACK FOOTER //
// ./src/style/index.js